module.exports = __webpack_public_path__ + "img/160380.56e491c5.jpg";